import React, { useState } from "react";
import { Button, Input } from "../components/Form";
import { BiLogInCircle } from "react-icons/bi";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import authService from "../api/authService";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!email || !password) {
        toast.error("Please provide email and password");
        setLoading(false);
        return;
      }
      await authService.login(email, password);
      toast.success("Login Successful");
      navigate("/");
    } catch (error) {
      const msg = error.response?.data?.message || "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex-colo h-screen w-full bg-dry'>
      <form onSubmit={submitHandler} className='flex-colo mx-auto w-2/5 rounded-2xl bg-white p-8'>
        <img
          src='/images/logo.png'
          alt='logo'
          className='h-16 w-48 object-contain'
        />
        <div className='mb-6 flex w-full flex-col gap-4'>
          <Input
            label='Email'
            type='email'
            color={true}
            placeholder={"admin@gmail.com"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label='Password'
            type='password'
            color={true}
            placeholder={"*********"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className='w-full mb-4 flex justify-end'>
          <Link to='/forgot-password' className='text-sm text-[#0095D9] hover:underline'>
            Forgot password?
          </Link>
        </div>
        <Button
          label={loading ? "Loading..." : "Login"}
          Icon={BiLogInCircle}
          onClick={submitHandler}
          disabled={loading}
        />
      </form>
    </div>
  );
}

export default Login;
